import {Injectable} from '@angular/core';
//import {CartData} from "../providers/products";
import {CustomerList} from "../providers/list-of-customers";
@Injectable()
export class ProductService{
     customerDetailsData = [];
    productData = [];
    selectedItems = [];
     CartDatalist=[];

    ProductService(){
       
    }
    loadProduct(){
       // this.productData = ProductsData;
        return this.productData;
    }
     

     getSelectedItems() {
	   return this.selectedItems;
	}	

    addItem(id:number): void {
       let item = this.productData.find(ob => ob.productid===id);
       let cartItem = this.selectedItems.find(ob => ob.productid === id);
       if (cartItem) {	 
                
	   } else {
            cartItem = Object.assign({}, item);
            cartItem.id = this.selectedItems.length+1;
            cartItem.quantityincart = 0;
            this.selectedItems.push(cartItem);
       }

       cartItem.quantityincart += 1;
    
    }
    

    loadCart(){
         //this.CartDatalist = CartData;  
        return this.CartDatalist;
    }

    
}




// WEBPACK FOOTER //
// ./src/app/providers/products.service.ts